import { ZoomOut as ZoomOutIcon } from '@material-ui/icons';
import { t } from '@lingui/macro';

import { Action } from './Actions';
import { useCanZoomOut } from '../../../stores/TimeRangeHistoryStore';
import { useTimeRangeNavigation } from '../../../utilities/TimeRangeNavigationUtilities';

export default function ZoomOutAction(props) {
    const [canZoomOut] = useCanZoomOut();
    const { enabled, zoomOut } = useTimeRangeNavigation();

    return enabled ? (
        <Action
            icon={<ZoomOutIcon />}
            tooltip={t`Zoom the time range out`}
            disabled={!canZoomOut}
            onClick={zoomOut}
            {...props}
        />
    ) : null;
}
